import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { List } from '@zillow/zrs-cms';
import { generateBlockList } from '../components/BlockList/BlockList.js';
import makeContentInteractive from '../util/makeSpansInteractive.js';

var _excluded = ["content"];
var BlockListItem = function BlockListItem(_ref) {
  var attrs = _ref.attrs,
    index = _ref.index,
    innerBlocks = _ref.innerBlocks;
  var content = attrs.content,
    restAttrs = _objectWithoutProperties(attrs, _excluded);
  return /*#__PURE__*/React.createElement(List.Item, _extends({
    key: index
  }, restAttrs), /*#__PURE__*/React.createElement("div", null, makeContentInteractive(content)), generateBlockList({
    blocks: innerBlocks
  }));
};
BlockListItem.propTypes = process.env.NODE_ENV !== "production" ? {
  attrs: PropTypes.shape({
    content: PropTypes.string
  }),
  index: PropTypes.number,
  innerBlocks: PropTypes.arrayOf(PropTypes.shape({}))
} : {};
var ListItem = BlockListItem;

export { ListItem as default };
